//UserInterface to define the State type for the state of the reducer

import {
  GET_CLASSROOM_FAILED_CC,
  GET_CLASSROOM_SUCCESS_CC,
  GET_SERVICE_CENTER_FAILED_CC,
  GET_SERVICE_CENTER_SUCCESS_CC,
  GET_SITE_FAILED_CC,
  GET_SITE_SUCCESS_CC,
  GET_SUB_RECIPIENT_FAILED_CC,
  GET_SUB_RECIPIENT_SUCCESS_CC,
  RESET_CC_DATA,
} from "../actionConstants";

interface AppInterface {
  siteList: any;
  serviceCenterList: any;
  subRecipientList: any;
  classroomList: any;
}

interface Actions {
  payload: any;
  type: string;
  token: string;
}

//State type for defining the state of the reducer
export type State = AppInterface;

//Initial state of the reducer of type State
export const initialState: State = {
  siteList: [],
  serviceCenterList: [],
  subRecipientList: [],
  classroomList: [],
};

export const CCReducers = (state: State = initialState, action: Actions) => {
  switch (action.type) {
    //if action is of type SIGN_IN or SIGN_UP return the state by setting token to the payload
    case GET_SITE_SUCCESS_CC:
      return {
        ...state,
        siteList: action.payload.data,
      };
    case GET_SITE_FAILED_CC:
      return {
        ...state,
        userList: [],
      };
    case GET_SERVICE_CENTER_SUCCESS_CC:
      return {
        ...state,
        serviceCenterList: action.payload.data,
      };
    case GET_SERVICE_CENTER_FAILED_CC:
      return {
        ...state,
        serviceCenterList: [],
      };
    case GET_SUB_RECIPIENT_SUCCESS_CC:
      return {
        ...state,
        subRecipientList: action.payload.data,
      };
    case GET_SUB_RECIPIENT_FAILED_CC:
      return {
        ...state,
        subRecipientList: [],
      };
    case GET_CLASSROOM_SUCCESS_CC:
      return {
        ...state,
        classroomList: action.payload.data,
      };
    case GET_CLASSROOM_FAILED_CC:
      return {
        ...state,
        classroomList: [],
      };
    case RESET_CC_DATA:
      return {
        ...state,
        siteList: [],
        serviceCenterList: [],
        subRecipientList: [],
        classroomList: [],
      };
    default:
      return state;
  }
};
